import { updateFooterLinks } from "./updateFooterLinks";
import { attachNextPrevClickEvent } from "./attachNextPrevClickEvent";
import { $ } from "../third-party-imports";
// import { start_loader, stop_loader} from "../util";

/**
 * Get All Blogs
 */
function estimateReadingtime(){
    if($('.blog-description').length){
        let articleText = $('.blog-description').text();
        // Split the text into an array of words
        let wordsArray = articleText.split(' ');
        // Count the number of words in the array
        let wordCount = wordsArray.length;
        // Calculate the estimated reading time
        let wordsPerMinute = 200;
        let readingTime = Math.ceil(wordCount / wordsPerMinute);
        let timeText = readingTime <= 1 ? 'minute' : 'minutes';
        $('.estimated-reading-time').append(`<div class="reading-time">${readingTime} ${timeText}</div>`);
    }    
}
export function getAllBlogs(g2CollectionURL: any){
    /*To show the loader only in online scheduler flow so commenting the loader [+57326] 
    start_loader();
    */
    $.ajax({
        type: 'GET',
        url: g2CollectionURL,
        dataType: 'json',
        headers : {'Accept-Encoding': 'gzip'},
        async: true,
        cache: false,
        success: function (data){
            var allBlogs = data.response.docs;
            estimateReadingtime();
            // Update Footer Links
            updateFooterLinks(allBlogs);
            // attach click event only if links are enabled.
            attachNextPrevClickEvent();
            // stop_loader();
        },
        error: function (e: any){
            // stop_loader();
            //console.log(e.message);
        }
    });
}
